<template>
  <h-frame type="left">
    <div class="homeLeft">
      <div class="itemDetail">
        <x-title>
          <div class="titleWidth">
            一标三实+N
            <!-- <div class="titleMore">
            更多
          </div> -->
          </div>
        </x-title>
        <div class="leftBox">
          <div
            class="leftItem"
            v-for="(item, index) in leftList"
            :key="index"
            @click="leftItemClick(item)"
          >
            <div class="itemleft">
              <i :class="['iconfont', 'iconimg', item.icon]"></i>
            </div>
            <div class="itemright">
              <span class="yellow">{{ item.value }}</span>
              <span class="whiteSize">{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="itemDetail">
        <x-title>
          <div class="titleWidth">人口统计</div>
        </x-title>
        <div class="leftpeople">
          <div class="peopleecharts">
            <div class="oneBox">
              <div
                class="oneItem"
                v-for="item in personStatistical.statisticalData"
                :key="item.id"
              >
                <span class="bluecolore">{{ item.name }}:</span>{{ item.value }}
              </div>
            </div>
            <div class="oneBluebg">
              <div
                class="bluecount"
                :style="{
                  width:
                    (100 / (personStatistical.num1 + personStatistical.num2)) *
                      personStatistical.num1 +
                    '%',
                }"
              >
                {{ personStatistical.num1 }}
              </div>
              <div class="noBlue">{{ personStatistical.num2 }}</div>
            </div>
          </div>
        </div>
        <populationRightThree
          @click="leftItemClick({ name: '人口' })"
        ></populationRightThree>
        <!-- <div class="echarts" id="echartsTopLeft" ></div> -->
      </div>
      <div class="itemDetail">
        <x-title>
          <div class="titleWidth">
            重点人员统计
            <!-- <div class="titleMore">
            更多
          </div> -->
          </div>
        </x-title>
        <div
          class="echarts"
          id="echartsbottomLeft"
          @click="leftItemClick({ name: '重点人员' })"
        ></div>
      </div>
    </div>
  </h-frame>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  nextTick,
  inject,
  watchEffect,
} from "vue";
import * as echarts from "echarts";
import util from "@util/js";
import { useRouter } from "vue-router";
import {
  getPrisonSex,
  getSecurity,
  getStrength,
  getEquipment,
  getHouseCount,
  getUnitCount,
  getEventCount,
  getImpotanceCount,
} from "@/api/home/home.js";
import { houseHoldType } from "@/api/dataAnalysis/populationAnalysis.js";
import populationRightThree from "@/views/dataAnalysis/populationAnalysis/components/populationRightThree";
export default defineComponent({
  name: "",
  components: { populationRightThree },
  props: {},
  setup(props) {
    const data = reactive({
      leftList: [
        { name: "人口", value: "0", icon: "icon-tianjia1", id: "1" },
        { name: "房屋", value: "0", icon: "icon-tianjia1", id: "2" },
        { name: "单位", value: "0", icon: "icon-tianjia1", id: "3" },
        { name: "警情事件", value: "0", icon: "icon-tianjia1", id: "4" },
        { name: "安防设施", value: "0", icon: "icon-tianjia1", id: "5" },
        { name: "力量装备", value: "0", icon: "icon-tianjia1", id: "6" },
      ],
      personSexDate: [
        { value: 0, name: "男" },
        { value: 0, name: "女" },
      ],
      personImportantDate: [
        // { value: 30, name: "涉黄" },
        // { value: 15, name: "前科" },
        // { value: 55, name: "涉毒" },
      ],
      personStatistical: {
        regionId: JSON.parse(localStorage.getItem("regionId")),
        statisticalData: [],
        num1: 0,
        num2: 0,
      },
      regionPrams: {
        regionId: util.getStorage("regionId"),
      },
    });
    const refData = toRefs(data);
    const router = useRouter();
    const regionInfo = inject("region");
    watchEffect(() => {
      if (regionInfo.regionList) {
        nextTick(() => {
          houseHoldTypelist();
          getPrisonSexAsync();
          getSecurityAsync();
          getStrengthAsync();
          getHouseCountAsync();
          getUnitCountAsync();
          getEventCountAsync();
          getImpotanceCountAsync();
        });
      }
    });
    const leftItemClick = (val) => {
      switch (val.name) {
        case "人口":
          router.push("DemographicInformation");
          break;
        case "房屋":
          router.push("houseInformation");
          break;
        case "单位":
          router.push("UnitInformation");
          break;
        case "警情事件":
          router.push("eventDispatch");
          break;
        case "安防设施":
          router.push("ActualSecurityFacilities");
          break;
        case "力量装备":
          router.push("actualEquipment");
          break;
        case "重点人员":
          router.push("keyPersonnelBase");
          break;
        default:
          break;
      }
    };
    // echarts
    let myChartTopLeft;
    let myechartsbottomLeft;

    // 第二个饼图
    function _pie2() {
      const dataArr = [];
      for (var i = 0; i < 8; i++) {
        if (i % 2 === 0) {
          dataArr.push({
            name: (i + 1).toString(),
            value: 35,
            itemStyle: {
              normal: {
                color: "rgba(112,180,248,1)",
              },
            },
          });
        } else {
          dataArr.push({
            name: (i + 1).toString(),
            value: 30,
            itemStyle: {
              normal: {
                color: "rgba(0,0,0,0)",
              },
            },
          });
        }
      }
      return dataArr;
    }
    // color: ['#3d8eb7', '#5dc8d8', '#ecab3c', '#ded747', '#67c99c', '#97b939'],
    const colorList = ["#3d8eb7", "#5dc8d8", "#ecab3c"];
    const echartsbottomLeft = () => {
      myechartsbottomLeft = echarts.init(
        document.getElementById("echartsbottomLeft")
      );
      const option = {
        title: {
          text: "",
          x: "center",
          y: "center",
          textStyle: {
            fontSize: 13,
            color: "#facd2b",
          },
        },
        color: colorList,
        tooltip: {
          trigger: "item",
          formatter: "{b}:{c} ({d}%)",
        },

        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["30%", "55%"],
            center: ["50%", "50%"],
            data: data.personImportantDate,
            label: {
              normal: {
                color: "#fff",
                formatter: (params) => {
                  return (
                    "{name|" +
                    params.name +
                    "}" +
                    " " +
                    "{percent|" +
                    params.percent.toFixed(2) +
                    "}" +
                    "%\n{hr|}"
                  );
                },
                padding: [0, -5, 25, -5],
                rich: {
                  name: {
                    fontSize: 13,
                    lineHeight: 25,
                  },
                  percent: {
                    fontSize: 14,
                  },
                  hr: {
                    // 中间线
                    borderColor: "#46e6c3",
                    width: "100%",
                    borderWidth: 1,
                    height: 0,
                  },
                },
              },
            },
            labelLine: {
              length: 33,
              length2: 0,
              lineStyle: {
                color: "#46e6c3",
                width: 2,
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
          {
            type: "pie",
            zlevel: 2,
            silent: true,
            center: ["50%", "50%"],
            radius: ["60%", "63%"],
            startAngle: 50,
            hoverAnimation: false,
            label: {
              normal: {
                show: false,
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: _pie2(),
          },
          {
            type: "pie",
            zlevel: 3,
            silent: true,
            center: ["50%", "50%"],
            radius: ["60%", "61%"],
            label: {
              normal: {
                show: false,
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: _pie2(),
          },
        ],
      };

      //   option && data.myChart.setOption(option);
      //   data.myChart.on('click', function(params) {
      //     context.emit('dialogSate', true); ;
      //   });
      // };
      myechartsbottomLeft.setOption(option, true);
    };

    //人户一致接口
    const houseHoldTypelist = async () => {
      let params = data.regionPrams;
      if (regionInfo.regionList.length > 0) {
        params = {
          regionIds: regionInfo.regionList.toString(),
        };
      }
      const res = await houseHoldType(params);
      data.personStatistical.statisticalData = res.data;
      data.personStatistical.num1 = res.data[0].value;
      data.personStatistical.num2 = res.data[1].value;
      {
      }
    };
    //性别接口
    const getPrisonSexAsync = async () => {
      let params = data.regionPrams;
      if (regionInfo.regionList.length > 0) {
        params = {
          regionIds: regionInfo.regionList.toString(),
        };
      }
      const res = await getPrisonSex(params);
      if (res) {
        data.personSexDate = res.data;
        data.leftList[0].value = res.data.reduce((total, item) => {
          return total + item.value;
        }, 0);
      }
    };
    //安防
    const getSecurityAsync = async () => {
      let params = data.regionPrams;
      if (regionInfo.regionList.length > 0) {
        params = {
          regionIds: regionInfo.regionList.toString(),
        };
      }
      const res = await getSecurity(params);
      if (res) {
        data.leftList[4].value = res.data.value;
      }
    };
    //设备+力量
    const getStrengthAsync = async () => {
      let params = data.regionPrams;
      if (regionInfo.regionList.length > 0) {
        params = {
          regionIds: regionInfo.regionList.toString(),
        };
      }
      const res = await getStrength(params);
      const ress = await getEquipment(params);
      if (res && ress) {
        data.leftList[5].value = res.data.value + ress.data.value;
      }
    };
    //房屋
    const getHouseCountAsync = async () => {
      let params = data.regionPrams;
      if (regionInfo.regionList.length > 0) {
        params = {
          regionIds: regionInfo.regionList.toString(),
        };
      }
      const res = await getHouseCount(params);
      if (res) {
        data.leftList[1].value = res.data.value;
      }
    };
    //单位
    const getUnitCountAsync = async () => {
      let params = data.regionPrams;
      if (regionInfo.regionList.length > 0) {
        params = {
          regionIds: regionInfo.regionList.toString(),
        };
      }
      const res = await getUnitCount(params);
      if (res) {
        data.leftList[2].value = res.data.value;
      }
    };
    //事件总量
    const getEventCountAsync = async () => {
      let params = data.regionPrams;
      if (regionInfo.regionList.length > 0) {
        params = {
          regionIds: regionInfo.regionList.toString(),
        };
      }
      const res = await getEventCount(params);
      if (res) {
        data.leftList[3].value = res.data.value;
      }
    };
    //重点人员
    const getImpotanceCountAsync = async () => {
      const params = {
        libraryFlag: "1",
        regionId: util.getStorage("regionId"),
        regionIds: regionInfo.regionList.toString(),
      };
      const res = await getImpotanceCount(params);
      if (res) {
        nextTick(() => {
          data.personImportantDate = res.data;
          echartsbottomLeft();
        });
      }
    };

    onMounted(() => {
      setTimeout(() => {
        echartsbottomLeft();
      }, 200);

      window.addEventListener("resize", () => {
        myChartTopLeft.resize();
        myechartsbottomLeft.resize();
      });
    });
    return { ...refData, leftItemClick };
  },
});
</script>
<style lang="scss" scoped>
.homeLeft {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  padding-top: 15px;
  overflow: auto;
  color: white;
  .itemDetail {
    height: 33%;
    .leftpeople {
      width: 100%;
      height: 45px;
      display: flex;
      flex-direction: column;
      // margin-bottom: 20px;
      .yellowColor {
        width: 100%;
        text-align: center;
        color: #1a1300;
        line-height: 40px;
      }
      .peopleecharts {
        display: flex;
        flex-direction: column;

        .oneBox {
          display: flex;
          justify-content: space-between;
          line-height: 30px;
          .bluecolore {
            color: #91c8ff;
          }
        }
        .oneBluebg {
          width: 100%;
          height: 30px;
          background: rgba(0, 143, 187, 1);
          border-radius: 4px;
          position: relative;

          .bluecount {
            width: 200px;
            text-align: center;
            // height: 100%;
            position: absolute;
            border-radius: 4px;
            box-shadow: 0 0 10px 3px #00c9fa inset;
            background: #00a8ec;
            z-index: 2;
            line-height: 30px;
          }
          .noBlue {
            position: absolute;
            right: 20px;
            line-height: 30px;
          }
        }
      }
    }
  }
  .titleWidth {
    width: 100%;
  }
  .leftBox {
    width: 100%;
    // height: 26%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    margin-top: 10px;
    .leftItem {
      width: 155px;
      height: 55px;
      background-image: url("~@/assets/images/home/item.png");
      display: flex;
      margin-bottom: 24px;
      cursor: pointer;
      .iconimg {
        background-image: -webkit-linear-gradient(#ace4fc, #76c5fa);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-size: 30px;
      }
      // justify-content:center;
      .itemleft {
        width: 68px;
        text-align: center;
        line-height: 55px;
      }
      .itemright {
        display: flex;
        flex-direction: column;
        line-height: 28px;
        .yellow {
          color: #f3ce61;
        }
        .whiteSize {
          // color: #a6bfda;
        }
      }
    }
  }
  //
  .titleMore {
    float: right;
    cursor: pointer;
    // margin-right: 15px;
    background: #5189b4;
    padding: 3px 8px;
    border-radius: 4px;
  }
  #echartsTopLeft {
    // width:300px;
    height: 90%;
  }
  #echartsbottomLeft {
    width: 400px;
    height: 90%;
  }
}
</style>
